export function isCryptoCurrencySelector(typeSelector: string | undefined): boolean {
  return typeSelector?.startsWith('cc-') ?? false;
}
